import { render, staticRenderFns } from "./ContentDeck.vue?vue&type=template&id=047cb1fa&scoped=true&"
import script from "./ContentDeck.vue?vue&type=script&lang=js&"
export * from "./ContentDeck.vue?vue&type=script&lang=js&"
import style0 from "./ContentDeck.vue?vue&type=style&index=0&id=047cb1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047cb1fa",
  null
  
)

export default component.exports